export default "__VITE_ASSET__D8kiNjBn__"